// extracted by mini-css-extract-plugin
export default {"delete":"DeleteModal_delete__jHOQT","action-btn":"DeleteModal_action-btn__5AIZy"};